import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProposalService } from 'src/app/_services/proposal.service';
import { APIErrorResponse } from 'src/app/_types/api-responses.types';
import {
  CreateLeadResponse,
  UpsertLeadRequest,
} from 'src/app/_types/proposals.type';
import { v4 } from 'uuid';

import { LeadFormComponent } from '../lead-form/lead-form.component';
import { SlideInModalComponent } from '../slide-in-modal/slide-in-modal.component';

@Component({
  selector: 'app-add-lead-modal',
  templateUrl: './add-lead-modal.component.html',
  styleUrls: ['./add-lead-modal.component.css'],
  standalone: true,
  imports: [CommonModule, SlideInModalComponent, LeadFormComponent],
})
export class AddLeadModalComponent {
  @Input()
  customerId!: string | null;

  @Input()
  memberId!: string | null;

  @Input()
  originalProposalId: string | null = null;

  @Input()
  navigateOnSuccess = false;

  isSubmitted: boolean = false;

  formId = `lead-form-${v4()}`;

  constructor(
    private readonly proposalService: ProposalService,
    private readonly toastr: ToastrService,
    private readonly router: Router
  ) {}

  saveLead(obj: UpsertLeadRequest) {
    this.proposalService.createLead(obj).subscribe({
      next: (res) => {
        this.toastr.success($localize`Lead ajouté avec succès`);

        this.leadCreated.emit(res.data);
        this.closeModal();
        this.isSubmitted = false;
        if (this.navigateOnSuccess) {
          this.router.navigate(['/proposal/lead/view', res.data.leadId]);
        }
      },
      error: (err: HttpErrorResponse) => {
        const apiError = err?.error as APIErrorResponse;
        this.toastr.error(
          apiError?.error?.clientErrorMessageInFrench ??
            apiError?.error?.clientErrorMessage ??
            $localize`Une erreur est survenue. Veuillez réessayer`
        );
        this.isSubmitted = false;
      },
    });
  }

  @ViewChild('modal') modal!: SlideInModalComponent;

  @ViewChild(LeadFormComponent) leadForm?: LeadFormComponent;

  @Output()
  leadCreated = new EventEmitter<CreateLeadResponse>();

  openModal() {
    this.modal.openModal();
  }

  closeModal() {
    this.modal.closeModal(false);
  }
}
